<template>
    <div>
        <div class="heading-travel-policy">
            <span :class="hotelRefundableObj.isActive ? 'tag is-success' : 'tag'">Standard rule</span>

            <div class="right-content">
                <div class="lefttext">
                    <p class="paragrapgh">{{ title }}</p>
                    <p>Trigger for room rates that are <span class="rule-config-variable" @click="isEdit = !isEdit">
                            {{ boolToStr(hotelRefundableObj.value) }}
                            <b-icon icon="pencil" size="is-small"></b-icon>
                        </span>
                    </p>
                </div>
                <div class="allbtns">
                    <b-switch :rounded="true" :value="hotelRefundableObj.isActive" v-model="hotelRefundableObj.isActive"
                        @input="hotelRefundable" :left-label="true">{{ hotelRefundableObj.isActive ? 'Active' :
                        'Inactive' }}
                    </b-switch>
                </div>
            </div>
        </div>
        <div v-if="isEdit" class="edittravelpolicy editTravel2">
            <HotelRefundable :refundableVal="refundableVal" @emitData="getValue" />
            <b-button @click="saveCall">SAVE</b-button>
        </div>
        <StandardRuleActions v-if="hotelRefundableObj.isActive && !isEdit" :ruleObj="hotelRefundableObj" :title="title"
            @save="updateActions" />
    </div>
</template>
<script>
import StandardRuleActions from "../StandardRuleActions.vue";
import HotelRefundable from "../CommonRules/HotelRefundable.vue";
export default {
    name: "",
    props: {
        value: {
            type: [Object],
        },
    },
    components: {
        HotelRefundable,
        StandardRuleActions
    },
    data() {
        return {
            refundableVal: false,
            hotelRefundableObj: this.value
                ? this.value
                : {
                    name: "hotelNonRefundable",
                    isActive: false,
                    type: "hotel",
                    message: "Trigger if rate is refundable.",
                    value: false
                },
            isEdit: false,
            emitedValue: null,
            title: "Refundability"
        };
    },
    methods: {
        hotelRefundable() {
            if (!this.hotelRefundableObj.isActive) {
                // Clear the custom action parameters when deactivating
                this.clearActionParams();
            } else {
                // Rebuild message when activating
                this.buildMessage();
            }

            this.emitRuleObj();
        },
        getValue(val) {
            this.emitedValue = val;
        },
        saveCall() {
            this.isEdit = false;
            this.hotelRefundableObj.value = this.emitedValue;
            this.buildMessage();
        },
        boolToStr(bool) {
            if (bool == true) {
                return 'Non-Refundable'
            } else {
                return 'Refundable'
            }
        },
        buildMessage() {
            this.hotelRefundableObj.message = "Trigger if rate is " + this.boolToStr(this.hotelRefundableObj.value);
        },
        emitRuleObj() {
            this.$emit("hotelRefundable", this.hotelRefundableObj);
        },
        clearActionParams() {
            // Reset to default actions when rule is not active ()
            this.hotelRefundableObj.useCustomActions = false;
            delete this.hotelRefundableObj.visibility;
            delete this.hotelRefundableObj.approvalLevel;
            delete this.hotelRefundableObj.notifications;
        },
        updateActions(updatedRule) {
            // Merge the updated properties into hotelRefundableObj
            this.hotelRefundableObj = { ...this.hotelRefundableObj, ...updatedRule };

            // If useCustomActions is false, delete the associated properties
            if (!updatedRule.useCustomActions) {
                this.clearActionParams();
            }

            this.buildMessage();

            this.emitRuleObj();
        },
    },
    mounted() {
        this.hotelRefundableObj.type = "hotel";

        this.emitRuleObj();
    },
    watch: {
        value: {
            handler(newVal, prevVal) {
                if (this.value) {
                    const hotelProps = this.value;
                    this.hotelRefundableObj = hotelProps
                    this.refundableVal = hotelProps.value;

                }
                this.hotelRefundableObj.type = "hotel";
                this.buildMessage();
                this.emitRuleObj();

            },
            deep: true,
        },
    },
};
</script>